import { SiteService } from '@app/_services/site.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { EMPTY, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import * as _ from 'lodash';
import { HttpErrorResponse } from '@angular/common/http';


@Injectable({ providedIn: 'root' })
export class SiteGuard  {
    constructor(
        private router: Router,
        private siteService: SiteService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        return this.siteService.getSiteDetails().pipe(

            catchError(error => {
                if (error instanceof HttpErrorResponse && error.status === 404) {
                    this.router.navigateByUrl('/not-found').then();
                }
                return EMPTY;
            }),
            map(res => {
                if (res.code == 200) return true;
                this.router.navigateByUrl('/').then();
                return false;
            }));

    }
}

@Injectable({ providedIn: 'root' })
export class ServicesGuard  {
    constructor(
        private router: Router,
        private siteService: SiteService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        if (this.siteService.features?.services == true) return true;
        this.router.navigateByUrl('/').then();
        return false;
    }
}
@Injectable({ providedIn: 'root' })
export class QuotationsFeatureGuard  {
    constructor(
        private router: Router,
        private siteService: SiteService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        if (this.siteService.features?.quotations == true) return true;
        this.router.navigateByUrl('/').then();
        return false;
    }
}
@Injectable({ providedIn: 'root' })
export class ProfessionalsGuard  {
    constructor(
        private router: Router,
        private siteService: SiteService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        if (this.siteService.features?.professionals == true) return true;
        this.router.navigateByUrl('/').then();
        return false;
    }
}
@Injectable({ providedIn: 'root' })
export class BlogsGuard  {
    constructor(
        private router: Router,
        private siteService: SiteService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        if (this.siteService.features?.blogs == true) return true;
        this.router.navigateByUrl('/').then();
        return false;
    }
}

@Injectable({ providedIn: 'root' })
export class VouchersGuard  {
    constructor(
        private router: Router,
        private siteService: SiteService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        if (this.siteService.features?.vouchers == true) return true;
        this.router.navigateByUrl('/').then();
        return false;
    }
}

@Injectable({ providedIn: 'root' })
export class LoyaltyGuard  {
    constructor(
        private router: Router,
        private siteService: SiteService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        if (this.siteService.features?.loyalty == true) return true;
        this.router.navigateByUrl('/').then();
        return false;
    }
}

@Injectable({ providedIn: 'root' })
export class ChatGuard  {
    constructor(
        private router: Router,
        private siteService: SiteService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        if (this.siteService.features?.chat == true) return true;
        this.router.navigateByUrl('/').then();
        return false;
    }
}

    let a :{abandonedCart?: boolean;
    services?: boolean;
    calendar?: boolean;
    quotations?: boolean;
    professionals?: boolean;
    promotions?: boolean;
    vouchers?: boolean;
    userManagement?: boolean;
    chat?: boolean;
    creditFacility?: boolean;
    loyalty?: boolean;
    priceList?: boolean;
    reports?: boolean;
    engagementReports?: boolean;
    moderation?: boolean;
    reviews?: boolean;
    blogs?: boolean;}
